import { Children, type ReactNode } from 'react';

type SlotsOnly = { children?: never };
export type WorkHomePageProps = SlotsOnly & {
  header: ReactNode;
  urgent: ReactNode;
  numbers?: ReactNode;
  primary: ReactNode;
  secondary?: ReactNode[];
};

/** Page grammar accepts named slots only, including for JavaScript callers. */
export function WorkHomePage(props: WorkHomePageProps) {
  if (Object.prototype.hasOwnProperty.call(props, 'children'))
    throw new Error('Page grammar accepts named slots only; children are not allowed');
  return (
    <div className="flex min-w-0 flex-col gap-4 break-words" data-page-grammar="work-home">
      {props.header}
      <div data-slot="urgent">{props.urgent}</div>
      {props.numbers}
      <div data-slot="primary" className="min-w-0">
        {props.primary}
      </div>
      {Children.toArray(props.secondary)}
    </div>
  );
}
